import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { useGlobalContext } from "../../GlobalContext";
import { Bell, Volume2, LogOut, VolumeX, ListTodo, MapPin } from "lucide-react";
import Logo from "../../Images/Packky.svg";
import AddTaskModal from "./AddTaskModal";
import ConfirmLogoutModal from "../Utils/./ConfirmLogoutModal";

export default function Header({ onAddTaskClick, showOld, setShowOld }) {
  const location = useLocation();
  const isDashboard = location.pathname === "/dashboard";
  const [modalOpen, setModalOpen] = useState(false);

  const {
    FetchTeamCall,
    isMuted,
    toggleMute,
  } = useGlobalContext();

  useEffect(() => {
    FetchTeamCall();
  }, []);

  // Reverse mapping:
  // showOld === true  -> Map View
  // showOld === false -> Task View
  const setTaskView = () => {
    if (typeof setShowOld === "function") setShowOld(false);
    else console.error("setShowOld is not a function!", setShowOld);
  };

  const setMapView = () => {
    if (typeof setShowOld === "function") setShowOld(true);
    else console.error("setShowOld is not a function!", setShowOld);
  };

  return (
    <div className="bg-yellow-50 text-white w-full shadow">
      <div className="flex items-center justify-between py-2 px-3">
        {/* LEFT: Segmented switch */}
        <div className="flex items-center gap-3">
          {isDashboard && typeof setShowOld === "function" && (
            <div className="flex items-center gap-3">
            

              {/* Segmented control (orange theme, overflow-safe) */}
              <div
                role="tablist"
                aria-label="Switch between Task and Map view"
                className="relative inline-grid grid-cols-2 w-[220px] rounded-full bg-[#FFFF] border border-[#fad9c0]  p-1"
              >
                {/* Sliding pill with inline width calc to avoid overflow */}
                <span
                  aria-hidden="true"
                  style={{
                    width: "calc(50% - 0.25rem)", // 50% minus the right-side gap inside p-1
                    transform: showOld ? "translateX(100%)" : "translateX(0%)",
                  }}
                  className="absolute top-1 bottom-1 left-1 rounded-full transition-transform duration-300 ease-in-out bg-white shadow"
                />

                {/* Task (now sets Task = showOld=false) */}
                <button
                  type="button"
                  role="tab"
                  aria-selected={!showOld}
                  onClick={setTaskView}
                  onKeyDown={(e) => {
                    if (e.key === "ArrowRight") setMapView();
                    if (e.key === "Enter" || e.key === " ") setTaskView();
                  }}
                  className={`relative z-10 flex items-center justify-center gap-2 px-3 py-2 rounded-full transition-colors
                    ${!showOld ? "text-[#F97316]" : "text-[#F97316]/70 hover:text-[#ea6a0e]"}`}
                >
                  <ListTodo className="h-4 w-4" />
                  <span className="text-sm font-medium">Task</span>
                </button>

                {/* Map (now sets Map = showOld=true) */}
                <button
                  type="button"
                  role="tab"
                  aria-selected={showOld}
                  onClick={setMapView}
                  onKeyDown={(e) => {
                    if (e.key === "ArrowLeft") setTaskView();
                    if (e.key === "Enter" || e.key === " ") setMapView();
                  }}
                  className={`relative z-10 flex items-center justify-center gap-2 px-3 py-2 rounded-full transition-colors
                    ${showOld ? "text-[#F97316]" : "text-[#F97316]/70 hover:text-[#ea6a0e]"}`}
                >
                  <MapPin className="h-4 w-4" />
                  <span className="text-sm font-medium">Map</span>
                </button>
              </div>
            </div>
          )}
        </div>

        {/* CENTER: Logo */}
        <img src={Logo} alt="Logo" className="h-7 mx-auto" />

        {/* RIGHT: Actions */}
        <div className="space-x-3 flex items-center">
          {isDashboard && (
            <button
              className="bg-orange-500 hover:bg-orange-600 px-3 py-1 rounded text-sm text-white"
              onClick={onAddTaskClick}
            >
              Add New Task
            </button>
          )}

          <button
            onClick={toggleMute}
            title={isMuted ? "Unmute Notifications" : "Mute Notifications"}
            className="p-2 rounded hover:bg-orange-100 transition"
          >
            {isMuted ? (
              <VolumeX className="w-5 h-5 text-orange-600" />
            ) : (
              <Volume2 className="w-5 h-5 text-orange-600" />
            )}
          </button>

          <Bell size={18} className="text-orange-600 cursor-pointer" />

          <ConfirmLogoutModal
            trigger={<LogOut size={18} className="text-orange-600 cursor-pointer" />}
          />

          {/* outer Components */}
          {/* <AddTaskModal
            isOpen={modalOpen}
            onClose={() => setModalOpen(false)}
          /> */}
        </div>
      </div>
    </div>
  );
}
